import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Galleries } from '../../api/Queries/get'
import { Context } from '../../Store/context'
import { ArrowRight } from '@mui/icons-material'

const Pictures = () => {
    const { t, i18n } = useTranslation()
    const [pictures, setPictures] = useState([])
    const { showError } = useContext(Context);

    const getPictureName = (p) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return p?.rus_name;
        } else if (currentLang === 'en') {
            return p?.eng_name;
        }
        return p?.tkm_name;
    };

    useEffect(() => {
        const getNewsTable = async () => {
            try {
                const res = await Galleries()
                setPictures(res)
            } catch (error) {
                showError(error.message);
            }
        }
        getNewsTable()
    }, [showError])

    const slicePictures = pictures.slice(0, 6)

    return (
        <div className='pb-12 w-full h-max bg-white dark:bg-dark media'>                       
            <div className='flex justify-between'>
                <h1 className='font-bold text-xl xl:text-2xl dark:text-dark-text'>
                    {t('photomaterials')}
                </h1>
                <Link
                    to='/gallery'
                    className='font-bold text-primary flex 
                          items-center hover:border-b-2 
                          dark:text-dark-text'
                >
                    <p>{t('all_button')}</p>
                    <ArrowRight className='mt-1' />
                </Link>
            </div>

            <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3  
                            gap-2 rounded-2xl mt-6'>
                {slicePictures?.map((pic) => (
                    <div className='relative' key={pic.id}>
                        <Link to={`/images/${pic.id}`}>
                            <img
                                src={pic.images[0]?.image ? pic.images[0]?.image : ''}
                                alt="images"
                                loading="lazy"
                                className='w-full xl:h-72 rounded-2xl object-cover'
                            />
                            <div className="w-full absolute bottom-0 bg-gradient-to-t from-black 
                                   text-white px-5 pb-4 pt-8 flex  flex-col rounded-bl-2xl 
                                   rounded-br-2xl">
                                <span className="text-xs mb-2">{pic.date}</span>
                                <div className="flex justify-between items-center">
                                    <p className="w-11/12 font-medium text-sm">{getPictureName(pic)}</p>
                                    <div className="bg-black border-2 border-white w-7  h-7 flex 
                                        justify-center items-center relative">
                                        <div className="absolute bottom-0.5 right-0.5  bg-black 
                                                    text-white text-xs border-2 border-white w-7
                                                    h-7 flex justify-center items-center"
                                        >
                                            {pic?.images?.length}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Pictures